<p-dialog
  header="Search"
  [modal]="true"
  [(visible)]="visible"
  [closable]="false"
  [focusOnShow]="false"
  position="top"
  [style]="{ width: '400px', marginTop: '75px' }"
>
  <div class="content">
    <div class="body">
      <div class="search-group">
        <p-dropdown
          [options]="seatOptions"
          [(ngModel)]="selectedSeat"
          optionLabel="label"
          appendTo="body"
          placeholder="Seat"
        />
        <input
          type="text"
          placeholder="Sequence Number"
          pInputText
          [(ngModel)]="selectedSequence"
          inputmode="numeric"
        />
        <p-calendar
          [(ngModel)]="selectedDate"
          [readonlyInput]="true"
          appendTo="body"
          placeholder="Sequence Date"
          [inline]="false"
          [minDate]="minDate"
        />
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: 1rem;
      "
    >
      <p-button
        label="Cancel"
        severity="info"
        [text]="true"
        (onClick)="closeDialog()"
      />
      <p-button
        type="submit"
        label="Search"
        severity="info"
        (onClick)="onSearch()"
        [disabled]="!selectedSequence || !selectedDate || !selectedSeat"
      />
    </div>
  </div>
</p-dialog>
